import React, { Component } from 'react';

function commaizeAffiliation(affiliation) {
  return Object.getOwnPropertyNames(affiliation).reduce((substr, elt, i) => {
    return elt ? substr + `${i === 0 ? '' : ', '}${affiliation[elt]}` : substr;
  }, '');
}

export class Affiliation extends Component {
  render() {
    return <div>{commaizeAffiliation(this.props.affiliation)}</div>;
  }
}
